import { ready } from "./utils.js";

ready(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
        if (entry.isIntersecting) {
            // section is visible
            entry.target.classList.add('isinview');
        } else {
            // section is not visible
            entry.target.classList.remove('isinview');
        }
        },
        {
            root: null,      // viewport
            threshold: 0.3  // trigger as soon as 30% is visible
        }
    );

    // Get all <section> elements with class "appearanim-1"
    const sections = document.querySelectorAll('section.appearanim-1');

    // For each of these sections, observe them
    sections.forEach(section => {
        observer.observe(section);
    });
});
